(function (root) {
  'use strict';
  const TOKEN = '_Holiday configuration', REVISION = '_Holiday revision';
  const packages = [15429861605476, 15464502165604, 15429862031460, 15429862096996];
  const addons = { wreathLights: 15457992736868, lights: 15446972399716, bells: 15446972432484, removal: 15446972465252 };
  const wreathVariants = {
    15464502165604: { 67925326463076: 1, 67925326495844: 1, 67925326528612: 2, 67925326561380: 2 },
    15429861605476: { 67734927736932: 1, 67822965456996: 2 },
    15429862031460: { 67734930391140: 1, 67822965915748: 2, 67822965948516: 1, 67822965981284: 2 },
    15429862096996: { 67734930423908: 1, 67822966014052: 2, 67822966046820: 1, 67822966079588: 2 }
  };
  const review = 'This Holiday configuration needs review before it can be changed.';
  const conflict = 'This Edit changed in another window. Return to your cart and open it again before saving.';
  const uncertain = 'We could not confirm the cart update. Reload your cart before making another change.';
  const stable = value => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
  const variant = line => String(line.variant_id || line.id);
  const tokenLines = (cart, token) => cart.items.filter(line => line.properties?.[TOKEN] === token);
  const signature = line => JSON.stringify([String(line.product_id || ''), variant(line), stable(line.properties), line.quantity]);
  const fingerprint = lines => lines.map(signature).sort().join('|');
  const identity = (line, item) => variant(line) === variant(item) && stable(line.properties) === stable(item.properties);
  function group(cart, token) {
    if (!Array.isArray(cart?.items) || typeof token !== 'string' || !token) throw Error(review);
    const lines = tokenLines(cart, token), parents = lines.filter(line => packages.includes(Number(line.product_id)));
    if (parents.length !== 1 || parents[0].quantity !== 1) throw Error(review);
    const seen = new Set();
    for (const line of lines) {
      const id = Number(line.product_id);
      if (![...packages, ...Object.values(addons)].includes(id) || seen.has(id) || !line.key || !Number.isSafeInteger(line.quantity) || line.quantity < 1 || line.selling_plan_allocation) throw Error(review);
      seen.add(id);
      if ((id !== addons.bells && id !== addons.wreathLights && line.quantity !== 1) || line.quantity > 99) throw Error(review);
      if (id === addons.wreathLights) {
        const parent = parents[0], count = wreathVariants[parent.product_id]?.[variant(parent)];
        const doors = parent.properties?.['Door configuration'];
        if (!count || line.quantity !== count || doors !== (count === 2 ? 'Double doors — two wreaths' : 'Single door — one wreath')) throw Error(review);
      }
      if (id === addons.lights && Number(parents[0].product_id) === packages[0]) throw Error('Garland Twinkle Lights are not available for The Welcome.');
    }
    return lines;
  }
  function changes(cart, token, action) {
    const lines = group(cart, token), output = {};
    if (action.type === 'remove-group') { lines.forEach(line => { output[line.key] = 0; }); return output; }
    const line = action.type === 'bells' ? lines.find(item => Number(item.product_id) === addons.bells) : lines.find(item => item.key === action.key);
    if (!line || packages.includes(Number(line.product_id))) throw Error('This add-on has changed. Reload your cart before trying again.');
    const quantity = action.type === 'remove-addon' ? 0 : action.quantity;
    if (action.type !== 'remove-addon' && (action.type !== 'bells' || !Number.isSafeInteger(quantity) || quantity < 0 || quantity > 99)) throw Error('Enter a whole bell trio quantity of 0–99.');
    output[line.key] = quantity;
    return output;
  }
  async function read(request, route) {
    const response = await request(route + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw Error('Your cart could not be checked. Please reload before trying again.');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw Error(review);
    return cart;
  }
  async function post(request, route, endpoint, body) {
    const response = await request(route + endpoint, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const result = await response.json();
    if (!response.ok) throw Error(String(result.description || result.message || 'This change could not be saved.'));
    return result;
  }
  function locked(work) {
    if (root.navigator?.locks?.request) return root.navigator.locks.request('ff-holiday-cart', { mode: 'exclusive' }, work);
    const next = (locked.pending || Promise.resolve()).then(work, work);
    locked.pending = next.catch(() => {});
    return next;
  }
  function blocked(message) { return Object.assign(Error(message || uncertain), { uncertain: true }); }
  async function mutate(request, route, token, action) {
    return locked(async () => {
      const before = await read(request, route), lines = group(before, token), update = changes(before, token, action);
      const desired = lines.filter(line => update[line.key] !== 0).map(line => ({ ...line, quantity: update[line.key] ?? line.quantity }));
      try { await post(request, route, action.type === 'bells' ? 'cart/change.js' : 'cart/update.js', action.type === 'bells' ? { id: Object.keys(update)[0], quantity: action.quantity } : { updates: update }); } catch (error) {
        let after; try { after = await read(request, route); } catch (_) { throw blocked(); }
        if (fingerprint(tokenLines(after, token)) === fingerprint(desired)) return after;
        if (fingerprint(tokenLines(after, token)) === fingerprint(lines)) throw Error('Your cart was not changed. ' + error.message);
        throw blocked();
      }
      const after = await read(request, route).catch(() => { throw blocked(); });
      if (fingerprint(tokenLines(after, token)) !== fingerprint(desired)) throw blocked();
      if (desired.length) group(after, token);
      return after;
    });
  }
  async function replace(request, route, token, expected, desired, revision) {
    return locked(async () => {
      const before = await read(request, route), original = group(before, token);
      if (fingerprint(original) !== expected) throw Error(conflict);
      if (!revision || typeof revision !== 'string' || !Array.isArray(desired) || !desired.length) throw Error(review);
      const hypothetical = desired.map((item, i) => ({ ...item, key: 'desired-' + i, variant_id: item.id }));
      group({ items: hypothetical }, token);
      const keep = [], staged = [], removed = [];
      desired.forEach(item => {
        const match = original.find(line => identity(line, item) && line.quantity >= item.quantity);
        if (match) keep.push({ original: match, desired: item });
        else staged.push({ ...item, properties: { ...item.properties, [REVISION]: revision } });
      });
      original.forEach(line => { if (!keep.some(item => item.original === line)) removed.push(line); });
      const target = [...keep.map(item => item.desired), ...staged];
      if (fingerprint(hypothetical) === fingerprint(original)) return before;
      const isTarget = cart => {
        const lines = tokenLines(cart, token);
        return lines.length === target.length && target.every(item => lines.some(line => identity(line, item) && line.quantity === item.quantity));
      };
      let posted = false, commitStarted = false;
      try {
        if (staged.length) {
          posted = true;
          await post(request, route, 'cart/add.js', { items: staged.map(({ product_id, ...item }) => item) });
        }
        const current = await read(request, route);
        const originalsNow = tokenLines(current, token).filter(line => line.properties?.[REVISION] !== revision);
        if (fingerprint(originalsNow) !== expected) throw Error(conflict);
        const addedNow = tokenLines(current, token).filter(line => line.properties?.[REVISION] === revision);
        if (addedNow.length !== staged.length || !staged.every(item => addedNow.some(line => identity(line, item) && line.quantity === item.quantity))) throw Error('The new selections could not be confirmed.');
        const updates = {};
        removed.forEach(old => { const line = originalsNow.find(item => signature(item) === signature(old)); if (!line) throw Error(conflict); updates[line.key] = 0; });
        keep.forEach(item => { if (item.original.quantity !== item.desired.quantity) { const line = originalsNow.find(line => signature(line) === signature(item.original)); if (!line) throw Error(conflict); updates[line.key] = item.desired.quantity; } });
        if (Object.keys(updates).length) { posted = true; commitStarted = true; await post(request, route, 'cart/update.js', { updates }); }
        const after = await read(request, route);
        if (!isTarget(after)) throw Error('The saved selections could not be confirmed.');
        group(after, token);
        return after;
      } catch (error) {
        if (!posted) throw error;
        let current;
        try { current = await read(request, route); } catch (_) { throw blocked(); }
        if (isTarget(current)) { group(current, token); return current; }
        const unchangedOriginals = tokenLines(current, token).filter(line => line.properties?.[REVISION] !== revision);
        const baselineUnchanged = fingerprint(unchangedOriginals) === expected;
        if (commitStarted && !baselineUnchanged) throw blocked();
        const cleanup = {};
        tokenLines(current, token).filter(line => line.properties?.[REVISION] === revision).forEach(line => { cleanup[line.key] = 0; });
        try {
          if (Object.keys(cleanup).length) await post(request, route, 'cart/update.js', { updates: cleanup });
          const restored = await read(request, route);
          if (tokenLines(restored, token).some(line => line.properties?.[REVISION] === revision)) throw blocked();
          if (baselineUnchanged && fingerprint(tokenLines(restored, token)) !== expected) throw blocked();
        } catch (_) { throw blocked(); }
        throw Error(baselineUnchanged ? 'Your original Edit and add-ons are unchanged. ' + error.message : conflict);
      }
    });
  }
  const api = { TOKEN, REVISION, packages, addons, group, changes, fingerprint, read, locked, mutate, replace };
  root.FFHolidayCart = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);

